import React, { useState } from "react";
import request from 'request';
import ReactQueryParams from 'react-query-params';
import { useAuth0 } from "./react-auth0-wrapper";
import Loading from "./Loading";


var api_base_path = "https://api.api-university.com/v1";

const Accounts = () => {  
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [param_account_id, setParamAccountId] = useState("");
  const { getTokenSilently } = useAuth0();

  const callApi = async () => {
    try {
      const token = await getTokenSilently();
      console.log(token);
      var urlstr = api_base_path+'/bankdata/accounts';
      request({url:urlstr,headers:{'Authorization': `Bearer ${token}`}}, function(err, res, body){
        setLoading(false);
        if (err) {
          console.log(err);
        } else if (res.statusCode === 200){
          var bodyObj = JSON.parse(body);
          setItems(bodyObj);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const renderAccount = (account) => {
    var account_link = "/accounts?accountid="+account.account_id;
    var account_number = "";
    if (account.account_number.iban) account_number = account.account_number.iban;
    else if (account.account_number.sort_code) account_number = account.account_number.number+" Sort Code " + account.account_number.sort_code;
    var tablerowstyle = "table-row";
    if (account.account_id === param_account_id) tablerowstyle = "table-row-highlight";
    return (
      <tr className={tablerowstyle} key={account.account_id}>
        <td className="col account"><a href={account_link}><img src={account.provider.logo_uri} alt={account.provider.display_name} tooltip={account.provider.display_name} height="14px"/></a></td>
        <td className="col timestamp">{new Date(account.update_timestamp).toDateString()}</td>
        <td className="col account-name">{account.display_name}</td>
        <td className="col account-number">{account_number}</td>
        <td className="col account-bic">{account.account_number.swift_bic}</td>
        <td className="col currency">{account.currency}</td>
      </tr>
    );
  }

  const renderAccounts = (accountData) => {  
    var accountData_sorted = [];
    var accountItems = [];
    if (accountData){
      accountData_sorted = accountData.sort(function(a,b){if (b.provider.display_name < a.provider.display_name) return -1; else if (b.provider.display_name === a.provider.display_name) return 0; else return 1});
      accountItems = accountData_sorted.map(renderAccount);
    }
    return (
      <div><center>      
        <table className="supertable"><tbody>
          <tr className="table-header">
            <td className="col account">Provider</td>
            <td className="col timestamp">Last Sync</td>
            <td className="col account-name">Account</td>
            <td className="col account-number">Account Number</td>
            <td className="col account-bic">BIC</td>
            <td className="col currency">Currency</td>
          </tr>
          {accountItems}
        </tbody></table>
      </center></div>      
    );
  }

  //callApi();
  var analysis = []; //renderAccounts(items);
  var loading_out = "";
  if (loading){
    loading_out = <Loading />;
  }  

  return (
        <div>
          {analysis}
          {loading_out}
        </div>
  );
  
}
export default Accounts;



// WEBPACK FOOTER //
// ./src/Analysis.js